<template>
  <main class="home-page">
    <router-view />
    <HeadBar />
    <el-divider />
    <div class="layout">
      <StaffOverview />
      <LineNotifyQuota />
      <ShopUsageSummary />
    </div>
  </main>
</template>

<script>
import HeadBar from './components/HeadBar.vue'
import ShopUsageSummary from './components/ShopUsageSummary.vue'
import StaffOverview from './components/StaffOverview.vue'
import LineNotifyQuota from '@/components/Progress/LineNotifyQuota.vue'

// GIMMATEK 店家首頁：只保留基本資訊列與四個統計欄位，不顯示 banner、公告、幫助中心（CNCY-10767）
// StaffOverview：分店綁定服務人員的今日預約、下一位顧客、本月業績、AI 個人績效優勢（一間分店代表一位服務人員）
export default {
  name: 'HomePage',
  components: { HeadBar, StaffOverview, ShopUsageSummary, LineNotifyQuota },
  mounted () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  },
}
</script>

<style lang="postcss" scoped>
.layout {
  @apply flex flex-col gap-[16px];
}
</style>
